import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import styles from './style.module.less'
import store from './store'
import { observer } from 'mobx-react'
import { Tabs, Button, Input } from 'hljd'
import { JUKE_PATH_A } from '@constant'

const TabPane = Tabs.TabPane

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    const {
      location: {
        query: { num, give }
      }
    } = props
    store.num = num
    store.give = give
  }

  componentDidMount() {
    store.getDetails()
  }

  render() {
    let header = [<a href={JUKE_PATH_A}>聚客宝</a>, '活动点购买']

    const {
      num = 10,
      give,
      data: { pay_money = 0, wallet = 0 },
      disabled,
      user_name,
      user_idcard,
      user_bankcard,
      user_phone
    } = store
    let total
    if (give) {
      total = +num + +give
    } else {
      total = +num
    }

    return (
      <HeaderView title="活动点购买" header={header}>
        <div className={styles.box}>
          <p className={styles.num}>
            <span>购买点数</span>
            {total}
          </p>
          <p className={styles.num}>
            <span>费用金额</span>￥{pay_money}
          </p>

          <div className={styles.pay}>
            <Tabs>
              <TabPane tab="余额支付" key="1">
                <p className={styles.tip}>
                  提醒：当前可提现收入即为您可用的余额
                </p>

                <p className={styles.num}>
                  <span>
                    当前可用余额为&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </span>￥{wallet}
                </p>
                <p className={styles.num}>
                  <span>购买当前服务需扣款</span>￥{pay_money}
                </p>

                <div className={styles.btnBox}>
                  <Button
                    type="primary"
                    disabled={disabled}
                    onClick={store.payWallet}
                  >
                    确认购买
                  </Button>
                </div>
              </TabPane>
              <TabPane tab="银行卡支付" key="2">
                <ul className={styles.card}>
                  <li>
                    <span className={styles.must}>真实姓名</span>
                    <Input
                      placeholder="请输入真实姓名"
                      style={{ width: 400 }}
                      value={user_name}
                      onChange={store.changeField('user_name')}
                    />
                  </li>
                  <li>
                    <span className={styles.must}>身份证号</span>
                    <Input
                      placeholder="请输入身份证号"
                      style={{ width: 400 }}
                      value={user_idcard}
                      onChange={store.changeField('user_idcard')}
                    />
                  </li>
                  <li>
                    <span className={styles.must}>银行账号</span>
                    <Input
                      placeholder="请输入银行卡账号"
                      style={{ width: 400 }}
                      value={user_bankcard}
                      onChange={store.changeField('user_bankcard')}
                    />
                  </li>
                  <li>
                    <span className={styles.must}>银行预留手机号</span>
                    <Input
                      placeholder="请输入银行预留手机号"
                      style={{ width: 400 }}
                      value={user_phone}
                      onChange={store.changeField('user_phone')}
                    />
                  </li>
                </ul>
                <div className={styles.btnBox}>
                  <Button type="primary" onClick={store.payCard}>
                    确认购买
                  </Button>
                </div>
              </TabPane>
            </Tabs>
          </div>
        </div>
      </HeaderView>
    )
  }
}
